const white = 0xffffff
const green = 0xff000
const gray = 0x808080	
export {
    white,
    green,
    gray
}